import script from "./CompanyInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyInfo.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyInfo.vue?vue&type=style&index=0&id=08c178fe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08c178fe"]])

export default __exports__